// react
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

// application
import productApi from '../../server/real/endpoints/products';
import { useProductTabs } from '../../services/hooks';

// blocks
import BlockCustomCarousel from '../blocks/BlockCustomCarousel';

function CustomCarousel(props) {
    const { section, region } = props;
    const {
        categories, title, layout, rows, source, limit, slideSpeed, images
    } = section;
    const featuredProducts = useProductTabs(
        useMemo(() => categories, [region]), (tab) => productApi.getProductsList({
            limit,
            category: tab && tab.categorySlug,
            source,
            region,
        }, {}, [], false),
        region,
    );

    const imageData = {
    "id": "949169b1-5e8b-c576-a3a6-a146be031737",
    "type": "customCarousel",
    "slides": [],
    "title": "test",
    "layout": "grid-4",
    "rows": 2,
    "limit": 10,
    "categories": [
        {
            "id": "6976f41f4267fadd1aa84321",
            "name": "View All",
            "items": 0,
            "children": [],
            "count": 0,
            "plateauLevelIds": []
        }
    ],
    "sort": 1,
    "slideSpeed": 0,
    "images": [
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "https://www.google.com"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/shop/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/shop/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
                {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        {
            "imageFull": "https://www.replink.net/evault/8F575BA6-7FD9-4AAC-8307-31AD0CB6AB9A/CDD70F4C-5769-4680-A79A-31BD85A483B3/CDD70F4C-5769-4680-A79A-31BD85A483B3-300.jpg",
            "link": "/cart"
        },
        
    ]
}

    return (
        <React.Fragment>
            (
                <BlockCustomCarousel
                    title={title}
                    layout={layout}
                    rows={rows}
                    slideSpeed={slideSpeed}
                    products={images}
                    loading={false}
                    groups={true}
                    onGroupClick={true}
                />
            )
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    region: state.region,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomCarousel);
